// src/Redux/actions/userActions.js
import API from "../../api.js";
import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGOUT,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_REGISTER_FAIL,
  USER_FORGOT_REQUEST,
  USER_FORGOT_SUCCESS,
  USER_FORGOT_FAIL,
  USER_RESET_REQUEST,
  USER_RESET_SUCCESS,
  USER_RESET_FAIL,
} from "../constants/userConstants.js";

export const login = (emailOrMr, password) => async (dispatch) => {
  try {
    dispatch({ type: USER_LOGIN_REQUEST });
    const { data } = await API.post("/auth/login", { emailOrMr, password });
    dispatch({ type: USER_LOGIN_SUCCESS, payload: data });
    localStorage.setItem("userInfo", JSON.stringify(data));
  } catch (error) {
    dispatch({
      type: USER_LOGIN_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
  }
};

// // optional wrapper - uses login endpoint under the hood
// export const loginByMr = (mrCode, password) => async (dispatch) => {
//   return dispatch(login(mrCode, password));
// };

export const register = (name, email, password, confirmPassword) => async (dispatch) => {
  try {
    if (password !== confirmPassword) {
      dispatch({
        type: USER_REGISTER_FAIL,
        payload: "Passwords do not match",
      });
      return;
    }

    dispatch({ type: USER_REGISTER_REQUEST });
    const { data } = await API.post("/auth/register", { name, email, password });
    dispatch({ type: USER_REGISTER_SUCCESS, payload: data });
    localStorage.setItem("userInfo", JSON.stringify(data));
  } catch (error) {
    dispatch({
      type: USER_REGISTER_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
  }
};

export const logout = () => (dispatch) => {
  localStorage.removeItem("userInfo");
  dispatch({ type: USER_LOGOUT });
};

// forgot password (send reset link)
export const forgotPassword = (email) => async (dispatch) => {
  try {
    dispatch({ type: USER_FORGOT_REQUEST });
    const { data } = await API.post("/auth/forgot-password", { email });
    dispatch({ type: USER_FORGOT_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({
      type: USER_FORGOT_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
    throw error;
  }
};

export const resetPassword = (token, password, confirmPassword) => async (dispatch) => {
  try {
    if (password !== confirmPassword) {
      dispatch({ type: USER_RESET_FAIL, payload: "Passwords do not match" });
      throw new Error("Passwords do not match");
    }

    dispatch({ type: USER_RESET_REQUEST });

    const { data } = await API.post(`/auth/reset-password/${token}`, { password });

    dispatch({ type: USER_RESET_SUCCESS, payload: data });

    return data; // return backend response so frontend can handle it
  } catch (error) {
    dispatch({
      type: USER_RESET_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
    throw error; // throw so frontend can catch it and show toast
  }
};

